// Constants without _OPTIONS are used to represent Backend Value
// Constants with _OPTIONS are used to map label and value of the SelectFieldOptions

export const IS_ACTIVE = {
  ENABLED  : 1,
  DISABLED : 0
}

export const IS_ACTIVE_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Enabled',
    'value' : IS_ACTIVE.ENABLED
  },
  {
    'label' : 'Disabled',
    'value' : IS_ACTIVE.DISABLED
  }
]

export const CALCULATION_TYPE = {
  ABSOLUTE   : 'absolute',
  PERCENTAGE : 'percentage'
}

export const PAYABLE_TO = {
  TINKERLUST  : 'tinkerlust',
  THIRD_PARTY : 'third_party'
}

export const CALCULATION_TYPE_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Absolute',
    'value' : CALCULATION_TYPE.ABSOLUTE
  },
  {
    'label' : 'Percentage',
    'value' : CALCULATION_TYPE.PERCENTAGE
  }
]

export const PER_PAGE = {
  5  : '5',
  10 : '10',
  25 : '25'
}

export const PER_PAGE_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : PER_PAGE[5],
    'value' : PER_PAGE[5]
  },
  {
    'label' : PER_PAGE[10],
    'value' : PER_PAGE[10]
  },
  {
    'label' : PER_PAGE[25],
    'value' : PER_PAGE[25]
  }
]